import {
  useDataTableExport,
  UseDataTableExportParams,
  UseDataTableExportReturn,
} from '@/hooks/useDataTableExport';
import { Task } from '@/services/types/client-intake-types';

import { TableColumnIds } from '../config/filterConfig';

/** Overrides for columns where frontend ID differs from backend CSV key. */
const TASK_CSV_KEY_OVERRIDES: Record<string, string> = {
  [TableColumnIds.TASK_STATUS]: 'canonical_status',
  [TableColumnIds.TASK_TYPE]: 'canonical_type',
  [TableColumnIds.LAST_UPDATE]: 'latest_update_at',
  [TableColumnIds.INCIDENT]: 'incident_type',
  [TableColumnIds.COVERAGE]: 'coverage_carrier',
  [TableColumnIds.LAST_UPDATE_ACTOR]: 'last_update_actor',
  [TableColumnIds.CMS_STATUS]: 'cms_status',
  [TableColumnIds.PRIORITY]: 'priority',
  [TableColumnIds.FIRM_PRIMARY_STATE]: 'firm_state',
  [TableColumnIds.RAINMAKER]: 'rainmaker',
};

type UseTaskExportParams = Omit<UseDataTableExportParams<Task>, 'config'>;

/** Hook for exporting tasks to CSV. */
export const useTaskExport = ({
  queryState,
  visibleColumns,
  allColumns,
}: UseTaskExportParams): UseDataTableExportReturn =>
  useDataTableExport<Task>({
    config: {
      endpoint: '/api/tasks/export/',
      entityName: 'tasks',
      csvKeyOverrides: TASK_CSV_KEY_OVERRIDES,
    },
    queryState,
    visibleColumns,
    allColumns,
  });
